import { useMutation, useQueryClient } from "@tanstack/react-query";
import { applicationForLeaveApi } from "../../../../../services/human-organization/application-for-leave.service";
import { notification } from "antd";

interface IVariable {
  id: string;
  body: any;
}

export const useUpdateAFL = () => {
  const queryClient = useQueryClient();
  const { mutate, ...restMutation } = useMutation({
    mutationFn: ({ id, body }: { id: string; body: any }) => {
      const request = applicationForLeaveApi.toRequest(body);
      return applicationForLeaveApi.update(id, request);
    },
  });

  const updateApplicationForLeave = (
    vars: IVariable,
    options?: {
      onSuccess?: (r: any) => void;
      successText?: string;
      errorText?: string;
    }
  ) => {
    mutate(vars, {
      onSuccess(response: any) {
        queryClient.invalidateQueries({
          queryKey: ["AFL-requests"],
        });
        notification.success({
          message: "Thành công!",
          description: options?.successText ?? `Duyệt yêu cầu thành công.`,
        });
        if (options?.onSuccess) options.onSuccess(response);
      },
      onError() {
        notification.error({
          message: "Thất bại",
          description: options?.errorText ?? `Duyệt yêu cầu thất bại.`,
        });
      },
    });
  };
  return { mutate, updateApplicationForLeave, ...restMutation };
};
